export enum TimeRecordsFiltersEnum {
  search = 'search',
  statuses = 'statuses',
  profiles = 'profiles',
  pspBranches = 'pspBranches',
  period = 'period',
  locations = 'locations',
}
